import axios from 'axios';
import React, { useState } from 'react';
import { render } from 'react-dom';
import './Home.css';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import NumericInput from 'react-numeric-input';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';


function Home({ children }) {
  const [menuSelection, setMenuSelection] = useState('');


  return (
    <div>
      <div className="row-mobile">
        <img className="steak-img-mobile" src="steak-3 mobile.jpg" alt="steak-img-mobile"/>
      </div>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <img src="steak-3.jpg" className="steak-img" alt="steak"/>
          <div className="overlay"><span className="overlay-text">Welcome to the Heritage House!<br/>
          <h6 className="sub-title-home-page">We look forward to hosting you at our Supper Club Restaurant, where we serve authentic
German and American classics. The Heritage House, one of America&#39;s oldest continuously
operating Supper Clubs, is located at the intersection of US Highways 23 and 14; the gateway
to Harvard, Illinois.<br/><br/>
            {/* <div className="lissie-signature">Lissie Lulofs</div><br/> */}
            </h6></span>
            <button className="book-table-button-text">Book a Table</button></div>
        </div>
        {/* <div className="col-md-1"></div> */}
      </div>
      <div class="location-wrapper">
        <div class="left-line-location-div">&nbsp;&nbsp;________________</div>
        <div class="mobile-location-line-div">&nbsp;&nbsp;location</div>
        <div class="right-line-location-div">&nbsp;&nbsp;_________________</div>
      </div>
      <div className="home-address-mask">
      <div className="home-page-address">
      <a className="apple-map-link" href="https://maps.apple.com/place?place-id=ID7C00AEDE3D54F20&address=21225+US-14%2C+Harvard%2C+IL++60033%2C+United+States&coordinate=42.397167%2C-88.613091&name=The+Heritage+House&_provider=9902">21225 East US Highway 14<br/>Harvard, Illinois  60033</a><br/><a className="home-page-phone" href="tel:+18159436153">(815) 943-6153</a>
            </div></div>
            <div class="hours-wrapper">
        <div class="left-line-location-div">&nbsp;&nbsp;________________</div>
        <div class="mobile-location-line-div">&nbsp;&nbsp;hours</div>
        <div class="right-line-location-div">_________________</div>
      </div><br/><div className="hours-mobile">
      <b><h8>Wednesday & Thursday</h8></b><br/>
      <h9>4pm to 9pm</h9><br/><br/>
      <b><h8>Friday & Saturday</h8></b><br/>
      <h9>4pm to 10pm</h9><br/><br/>
      <b><h8>Sunday</h8></b><br/>
      <h9>12pm Noon to 8pm</h9><br/><br/>
      <b><h8>Monday & Tuesday</h8></b><br/>
      <h9>Closed</h9></div>
      <div className="spacer-div"></div>
    </div>
  );}

export default Home;
